<template>
    <div id="app">
        <reo-header :isApp="isApp" :showCommon="showCommon"></reo-header>
        <router-view/>
        <confirm-dialog class="logout-forced" v-model="loginExpired" @confirmAction="refresh" v-if="logouted"></confirm-dialog>
        <reo-need-help v-if="!isApp && showCommon"></reo-need-help>
        <reo-footer v-if="!isApp && showCommon"></reo-footer>
        <reo-dialog
        v-if="loginError"
        :labelOfConfirm="$t('login_error.refresh')"
        :labelOfCancel="$t('login_error.login')"
        :title="$t('login_error.title')"
        :description="$t('login_error.des')"
        @confirm="refresh"
        @cancel="goToLogin"
        ></reo-dialog>
    </div>
</template>

<script>
import confirmDialog from '@/basic/confirmDialog';
import reoHeader from '@/view/Header';
import reoFooter from '@/view/Footer';
import reoNeedHelp from '@/components/needHelp';
import ReoDialog from '@/basic/Dialog';
import user from '@/api/user';
import { config } from 'CONFIG';
export default {
    name: 'App',
    components: {

        confirmDialog,
        reoFooter,
        reoHeader,
        reoNeedHelp,
        ReoDialog

    },
    mounted () {

        $( 'body' ).removeClass( 'not-mounted' );

    },
    data () {

        return {

            loginExpired: this.$t( 'errors.logout_forced' ),
            isApp: config.platform === 'app'

        };

    },
    methods: {

        refresh () {

            window.location.reload();
            this.$store.commit( 'LOGIN_ERROR', false );

        },
        goToLogin () {

            user.goToAccountCenter( true );
            this.$store.commit( 'LOGIN_ERROR', false );

        }

    },
    computed: {

        logouted () {

            return this.$store.state.logoutForced.status;

        },
        loginError () {

            return this.$store.state.loginError.status;

        },
        showCommon () {

            let path = this.$route.path;
            return !path.includes( '/user/invoice/' );

        }

    }
};
</script>

<style>
    .logout-forced #cancle-button{

        display: none;

    }
</style>



// WEBPACK FOOTER //
// src/App.vue